import { Stack, SxProps, Theme } from '@mui/material';
import { Typography } from '@sweep-io/sweep-design';

interface WrapperWithHeaderProps {
  children: React.ReactNode;
  title: string;
  sx?: SxProps<Theme>;
}

export const WrapperWithHeader = ({ children, title, sx }: WrapperWithHeaderProps) => {
  return (
    <Stack gap={2} pt={3} direction="column" sx={sx}>
      <Typography variant="body">{title}</Typography>
      {children}
    </Stack>
  );
};
